export class ConfigurationModel {
    webApiUrl: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/configuration.model.ts